import api from './Axios';

/**
 * Users API
 * Base: /api/users
 */

export const searchUsers = (query) =>
  api.get('/users/search', { params: { q: query } });

export const createUser = (data) =>
  api.post('/users', data);

export const getAllUsers = () =>
  api.get('/users');

export const getUserById = (userId) =>
  api.get(`/users/${userId}`);

export const updateUser = (userId, data) =>
  api.put(`/users/${userId}`, data);

export const deleteUser = (userId) =>
  api.delete(`/users/${userId}`);